import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { TabBar } from './components/TabBar.js';
import { TodayScreen } from './screens/Today.js';
import { DiaryScreen } from './screens/Diary.js';
import { AddScreen } from './screens/Add.js';
import { TrendsScreen } from './screens/Trends.js';
import { ProfileScreen } from './screens/Profile.js';

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <div className="app">
        <Routes>
          <Route path="/" element={<TodayScreen />} />
          <Route path="/diary" element={<DiaryScreen />} />
          <Route path="/add" element={<AddScreen />} />
          <Route path="/trends" element={<TrendsScreen />} />
          <Route path="/profile" element={<ProfileScreen />} />
        </Routes>
        <TabBar />
      </div>
    </BrowserRouter>
  );
}
